<template>
  <d-row>
    <d-col cols="6">
      <form-group>
        <template #label>
          <label :for="$t('input.label.start_date')">
            {{ $t('input.label.start_date') }}

            <span v-if="editMode">
                  &ast;
                </span>
          </label>
        </template>

        <template #input>
          <date-input v-model="d_splitDateFields.fromDate" :disabledTo="Date.now()" :id="$t('input.label.start_date')" :placeholder="$t('input.placeholder.start_date')" :readonly="!editMode" />
        </template>
      </form-group>
    </d-col>

    <d-col cols="6">
      <form-group>
        <template #label>
          <label :for="$t('input.label.start_time')">
            {{ $t('input.label.start_time') }}

            <span v-if="editMode">
                  &ast;
                </span>
          </label>
        </template>

        <template #input>
          <time-input v-model="d_splitDateFields.fromTime" :id="$t('input.label.start_time')" :placeholder="$t('input.placeholder.start_time')" :readonly="!editMode" />
        </template>
      </form-group>
    </d-col>

    <d-col cols="6">
      <form-group>
        <template #label>
          <label :for="$t('input.label.end_date')">
            {{ $t('input.label.end_date') }}

            <span v-if="editMode">
                  &ast;
                </span>
          </label>
        </template>

        <template #input>
          <date-input v-model="d_splitDateFields.toDate" :disabledTo="d_splitDateFields.fromDate" :id="$t('input.label.end_date')" :placeholder="$t('input.placeholder.end_date')" :readonly="!editMode" />
        </template>
      </form-group>
    </d-col>

    <d-col cols="6">
      <form-group>
        <template #label>
          <label :for="$t('input.label.end_time')">
            {{ $t('input.label.end_time') }}

            <span v-if="editMode">
                  &ast;
                </span>
          </label>
        </template>

        <template #input>
          <time-input v-model="d_splitDateFields.toTime" :id="$t('input.label.end_time')" :placeholder="$t('input.placeholder.end_time')" :readonly="!editMode" />
        </template>
      </form-group>
    </d-col>
  </d-row>
</template>

<script>
import * as moment from 'moment-timezone';
import DateInput from '@/components/common/form/DateInput';
import TimeInput from '@/components/common/form/TimeInput';

export default {
  name: 'order-date-form-group',
  components: { DateInput, TimeInput },
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      d_value: this.value,
      d_splitDateFields: {},
    };
  },
  created () {
    this.splitDateFields();
  },
  methods: {
   
    splitDateFields () {
  
      this.d_splitDateFields = {
       
        fromDate: moment(this.d_value.start).tz(this.d_value.time_zone).format('YYYY-MM-DD'),
        fromTime: moment(this.d_value.start).tz(this.d_value.time_zone).format('HH:mm:ss'),
        toDate: moment(this.d_value.end).tz(this.d_value.time_zone).format('YYYY-MM-DD'),
        toTime: moment(this.d_value.end).tz(this.d_value.time_zone).format('HH:mm:ss'),
      };
    },
    formatDateTime () {
      ['from', 'to'].forEach(prop => {
        const propDate = this.d_splitDateFields[prop + 'Date'];
        const propTime = this.d_splitDateFields[prop + 'Time'];

        if (propDate && propTime) {
          this.d_value[prop] = moment.tz(`${propDate} ${propTime}`, this.d_value.time_zone).toISOString(true);
        }
      });
    },
  },
  watch: {
    editMode () {
      if (! this.editMode) {
        this.splitDateFields();
      }
    },
    value () {
      this.d_value = this.value;

      this.splitDateFields();
    },
    d_value: {
      handler () {
        if (!this.editMode) {
          return;
        }

        this.$emit('input', this.d_value);
      
      },
      deep: true
    },
    d_splitDateFields: {
      handler () {
        if (!this.editMode) {
          return;
        }

        this.formatDateTime();
      },
      deep: true
    }
  }
};
</script>
